import { ConnectedAppAuth } from './connected-app';
import { FormQueryExternalOperation, FormSubmitExternalOperation } from './form-external-operation';
import { User } from './user';

export interface FormTemplate {
    id: number;
    path: string;
    description: string;
    form_type_id: FormTemplateType;
    version:number;
    author_user_id:number;
    author_user?: User;
    schema?: any;
    is_latest: boolean;
    is_draft: boolean;
    updated_at?: string;
    index_basename?: string;
    datagrid_field_keys?: string[];
    
    form_submit_external_operations?: FormSubmitExternalOperation[];
    form_query_external_operations?: FormQueryExternalOperation[];

    external_access_token?: string;
    
    required_user_auths?: ConnectedAppAuth[];
}

export enum FormTemplateType {
    WEBFORM = 1,
    PDF = 2,
    FOLDER = 3
}
